import React from 'react';
import styled from 'styled-components';

const MessageSection = ({
  header,
  paragraph1,
  paragraph2,
  style,
}) => (
  <Container>
    { /* TODO: center */ }
    <ContainerSection style={style}>
      {header ? (
        <TextContainer><H1>{header}</H1></TextContainer>
      ) : null}
      {paragraph1 ? (
        <TextContainer><P>{paragraph1}</P></TextContainer>
      ) : null}
      {paragraph2 ? (
        <TextContainer><P>{paragraph2}</P></TextContainer>
      ) : null}
    </ContainerSection>
  </Container>
);

const Container = styled.div`
  height: 100%;
  align-items: center;
`;

const ContainerSection = styled.div`
  margin: 25px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 200px;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const H1 = styled.div`
  font-size: 35px;
  color: #5d81ec;
  margin-bottom: 0px;
  font-family: 'Karla', sans-serif;
`;

const P = styled.p`
  color: #a6b2ba;
  font-size: 16px;
  margin-bottom: 5px;
  font-family: 'Karla', sans-serif;
  text-align: center;
  max-width: 500px;
  margin-top: 10px;
`;

export default MessageSection;



// WEBPACK FOOTER //
// ./client/redesign/web/components/MessageSection/index.js